/*
 * Venn Platform API 1.0.0 Operations for "funds-v2"
 * Automatically generated file - do not modify!
 */

import type { ProxyMeta, ProxyVariantEnum } from '../types';
import type { OperationResult } from '../../utils';
import { buildQuery, buildRequestInit, extractError, retryGeneratedFetch } from '../../utils';

/** Get proxy for fund id */
export async function getProxyV2(
  id: string,
  proxySetId?: string,
  variant?: ProxyVariantEnum,
  signal?: AbortSignal,
): Promise<OperationResult<ProxyMeta>> {
  const endpoint = `/api/funds/proxy/v2/${encodeURIComponent(id)}${buildQuery({ proxySetId, variant })}`;
  const requestInit = buildRequestInit({ method: 'GET', signal });
  const response = await retryGeneratedFetch('GET', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: ProxyMeta = (await response.json()) as ProxyMeta;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Set the proxy for a fund */
export async function setProxyV2(body?: Partial<ProxyMeta>, signal?: AbortSignal): Promise<OperationResult<ProxyMeta>> {
  const endpoint = '/api/funds/proxy/v2';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await fetch(endpoint, requestInit);
  if (response.status >= 200 && response.status < 400) {
    const content: ProxyMeta = (await response.json()) as ProxyMeta;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
